import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableHeadComponent } from "../../common/TableHead";
import { checkOrX } from "./EditCameraUtils/checkOrX";

export const TimeTablesTable = ({
  timeTablesData,
}: {
  timeTablesData: any;
}) => {
  const titlesArray = ["Name", "Time", "Table"];

  return (
    <TableContainer component={Paper}>
      <Table
        sx={{ minWidth: 1000, fontFamily: "Mulish" }}
        aria-label="time_tables_table"
      >
        <TableHeadComponent titlesArray={titlesArray} />
        <TableBody>
          {timeTablesData.map((object: any) => {
            return (
              <TableRow key={object.id}>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {object.display_name ? <>{object.display_name}</> : "--"}
                </TableCell>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {object.time ? <>{object.time}</> : "--"}
                </TableCell>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {object.table ? (
                    <>
                      {checkOrX(object.is_actuate)} {object.table}
                    </>
                  ) : (
                    "--"
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
